// src/utils/commonUtils.ts
import { fetchFieldsByLanguage } from '../api/sections';
import type { Section } from '../api/types/core/sections';


export const fetchFields = async (language: string): Promise<Section[]> => {
  try {
    const fields = await fetchFieldsByLanguage(language);
    //console.log("Champs récupérés :", fields);
    determineSectionClasses(fields);
    return fields;
  } catch (error) {
    console.error("Erreur lors de la récupération des champs :", error);
    throw error;
  }
};

export const generateUUID = (): string => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};

export const initializeFormData = (sections: Section[], formData: Record<string, unknown>): void => {
  sections.forEach((section) => {
    initializeFormDataRecursive(section, formData);
  });
  //console.log("Données du formulaire initialisées :", formData);
};

const initializeFormDataRecursive = (field: Section, formData: Record<string, unknown>): void => {
  if (field.type && !formData[field.name]) {
    formData[field.name] = field.type === 'bool' ? null : "";
  }
  field.subsections.forEach((subField) => {
    initializeFormDataRecursive(subField, formData);
  });
};

export const buildMemoData = (sections: Section[], formData: Record<string, unknown>): Record<string, unknown> => {
  const memoData: Record<string, unknown> = {};
  sections.forEach((section) => {
    buildMemoDataRecursive(section, memoData, formData);
  });
  return memoData;
};

const buildMemoDataRecursive = (field: Section, memoData: Record<string, unknown>, formData: Record<string, unknown>): void => {
  if (field.type && formData[field.name]) {
    memoData[field.id] = formData[field.name];
  }
  field.subsections.forEach((subField) => {
    buildMemoDataRecursive(subField, memoData, formData);
  });
};

export const shouldDisplay = (field: Section): boolean => {
  return field.display !== false;
};

export const isFinalField = (field: Section): boolean => {
  const result = field.type !== null && field.subsections.length === 0;
  //console.log(`Le champ ${field.name} est un champ final : ${result ? "Oui" : "Non"}`);
  return result;
};


export const getSectionClass = (section: Section, level: number = 1): string => {
  const sectionClass = `section-level-${level}`;
  //console.log("Classe de la section :", sectionClass);
  return sectionClass;
};

// Exemple d'utilisation récursive pour déterminer le niveau d'imbrication
export const determineSectionClasses = (sections: Section[], level: number = 1): void => {
  sections.forEach((section) => {
    determineSectionClasses(section.subsections, level + 1); // Incrémente le niveau pour les sous-sections
  });
};

export const getSubSectionClass = (subSection: Section): string => {
  return `section-level-${subSection.importance || 1}`;
};